<template>
  <div class="top_box">
    <div class="big_title">发展历程</div>
    <img class="son_pic" src="@/assets/text/middle_son.png" alt="" />
    <img
      class="btn_pic left_pic"
      @mouseenter="enterFn"
      @mouseleave="leaveFn"
      @click="goleft"
      src="@/assets/text/leftBtn.png"
      alt=""
    />
    <img
      class="btn_pic right_pic"
      @mouseenter="enterFn"
      @mouseleave="leaveFn"
      @click="goright"
      src="@/assets/text/rightBtn.png"
      alt=""
    />
    <div class="imgBox" :style="{ right: position + 'vw' }">
      <img
        ref="bg_pic"
        class="bg_pic"
        src="@/assets/text/bg_swiper.png"
        alt=""
      />
      <div
        class="item_box"
        v-for="(item, index) in yearList"
        :key="'yaer' + index"
        :style="{
          bottom: item.position[1] + 'px',
          left: item.position[0] + 'px',
        }"
      >
        <div class="line_item" :style="{ height: item.height + 'px' }"></div>
        <div class="word_box" @mouseenter="enterFn" @mouseleave="leaveFn">
          <div class="title">{{ item.year }}</div>
          <div class="article" :title="item.content">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import api from "@/api/api";
import { ref, onMounted, onUnmounted } from "vue";
const position = ref(-8.33);
const animationId = ref(null);
const bg_pic = ref(null);
let yearList = ref([
  {
    year: "",
    content: "",
    position: [162, 562],
    height: "222",
  },
  {
    year: "",
    content: "",
    position: [362, 528],
    height: "319",
  },
  {
    year: "",
    content: "",
    position: [567, 395],
    height: "393",
  },
  {
    year: "",
    content: "",
    position: [770, 296],
    height: "455",
  },
  {
    year: "",
    content: "",
    position: [981, 408],
    height: "399",
  },
  {
    year: "",
    content: "",
    position: [1174, 240],
    height: "351",
  },
  {
    year: "",
    content: "",
    position: [1374, 342],
    height: "351",
  },

  {
    year: "",
    content: "",
    position: [1582, 350],
    height: "351",
  },
  {
    year: "",
    content: "",
    position: [1790, 408],
    height: "351",
  },
  {
    year: "",
    content: "",
    position: [1994, 460],
    height: "351",
  },
  {
    year: "",
    content: "",
    position: [2200, 354],
    height: "351",
  },
  {
    year: "",
    content: "",
    position: [2403, 438],
    height: "351",
  },
  {
    year: "",
    content: "",
    position: [2606, 518],
    height: "351",
  },
  {
    year: "",
    content: "",
    position: [2806, 696],
    height: "351",
  },
  {
    year: "",
    content: "",
    position: [3010, 844],
    height: "351",
  },
]);
const getList = async () => {
  let res = await api.getDevelopmentHistory();
  if (res.code === "0") {
    let value = res.res.data.sort((a, b) => a.year - b.year);
    value.forEach((item, index) => {
      if (yearList.value[index]) {
        yearList.value[index].year = item.year + "年";
        yearList.value[index].content = item.content;
      }
    });
  }
};
getList();
let lastTimestamp = ref(0);
const animate1 = (timestamp) => {
  // if (lastTimestamp.value === 0) {
  //   lastTimestamp.value = timestamp;
  // }
  const viewportWidth = window.innerWidth / 100;
  const picWidth = bg_pic.value.offsetWidth / viewportWidth - 108.33;
  let currentPosition = position.value;
  if (currentPosition < picWidth) {
    position.value += 0.015;
  } else {
    position.value = -8.33;
  }
  animationId.value = requestAnimationFrame(animate1);
  // lastTimestamp.value = timestamp;
};
const animate2 = (timestamp) => {
  let currentPosition = position.value;
  if (currentPosition > -8.33) {
    position.value -= 0.01;
    animationId.value = requestAnimationFrame(animate2);
  } else {
    animationId.value = requestAnimationFrame(animate1);
  }
  // lastTimestamp.value = timestamp;
};
const enterFn = () => {
  cancelAnimationFrame(animationId.value);
};
const leaveFn = () => {
  requestAnimationFrame(animate1);
};
const goleft = () => {
  let currentPosition = position.value;
  if (currentPosition > 1.67) {
    position.value -= 10;
  } else {
    position.value = -8.33;
  }
};
const goright = () => {
  const viewportWidth = window.innerWidth / 100;
  const picWidth = bg_pic.value.offsetWidth / viewportWidth - 108.33;
  let currentPosition = position.value;
  if (currentPosition + 10 < picWidth) {
    position.value += 10;
  } else {
    position.value = picWidth;
  }
};
onMounted(() => {
  requestAnimationFrame(animate1);
});
onUnmounted(() => {
  cancelAnimationFrame(animationId.value);
});
</script>
<style lang="less" scoped>
.item_box {
  position: absolute;
  display: flex;
  z-index: 3;
  .line_item {
    width: 1px;
    border-left: 2px dashed #006ab1;
    transform: translate(0px, 33px);
  }
  .word_box {
    width: 140px;
    padding-left: 20px;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 30px;
      color: #006ab1;
      line-height: 42px;
      text-align: left;
      font-style: normal;
      transition: all 0.6s ease;
    }
    .article {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 30px;
      text-align: justify;
      font-style: normal;
      width: 100%;
      // max-height: 330px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
  .word_box::before {
    content: "";
    width: 14px;
    height: 14px;
    border: 3px solid #006ab1;
    border-radius: 50%;
    position: absolute;
    top: 12px;
    left: -10px;
    z-index: 3;
    transition: all 0.6s ease;
  }
  .word_box:hover::before {
    transform: scale(1.1);
  }
  .word_box:hover {
    .title {
      // transform: scale(1.1);
      zoom: 1.1;
    }
  }
}
.big_title {
  position: relative;
  height: 5.27vh;
  font-weight: 600;
  font-size: 48px;
  line-height: 5.27vh;
  text-align: left;
  font-style: normal;
  color: #333333;
  margin-bottom: 3.38vh;
  font-family: PingFangSC, PingFang SC;
  z-index: 2;
}
.top_box {
  position: relative;
  width: 100%;
  height: 1195px;
  z-index: 2;
}
.son_pic {
  position: absolute;
  top: 32px;
  right: 227px;
  z-index: 3;
  width: 281px;
  height: 279px;
}
.btn_pic {
  position: absolute;
  top: 502px;
  z-index: 3;
  width: 62px;
  height: 62px;
  transition: all 0.6s ease;
  cursor: pointer;
}
.btn_pic:hover {
  transform: scale(1.1);
}
.left_pic {
  left: -243px;
}
.right_pic {
  right: 0;
}
.imgBox {
  position: absolute;
  width: 100%;
  height: 1402px;
  right: -8.33vw;
  top: -31px;
  z-index: 1;
  // overflow-x: auto;
  .bg_pic {
    position: absolute;
    height: 99%;
  }
}
</style>
